import "./BackgroundComponent.css";
import { useLocation } from "react-router-dom";
import {useState, useEffect } from "react";

export default function BackgroundComponent() {
  const location = useLocation(); 
  const [appliedColor, setAppliedColor] = useState("default");

  useEffect(() => {
    if (location.pathname.includes("/dashboard/invoices")) {
      setAppliedColor("invoices light");
    } else if( location.pathname.includes("/dashboard/inventory")) {
      setAppliedColor("inventory light");
    }else {
      setAppliedColor("default light");
    }
  }, [location.pathname]);

  return (
    <div id="hex-grid">
      <div className={appliedColor}></div>
      <div className="grid"></div>
    </div>
  );
}
